import React from "react";




const CallData = ({ callData }) => {

    return (
        <div className="text-start">
            <p className="mb-0 me-3 ">{callData.call_status_label}</p> 
       

        

          
        </div>
    );
};

export default CallData;
